export default __webpack_public_path__ + "static/media/graph-icon-green.4b3a0a47.svg";